<template>
  <div>
    <div class="detail" >
      <div class="detailDiv">
        共有 {{tableData.length}} 条支付明细可申请开票 <span class="valueamounttext">总金额：</span><span class="valueamount">￥{{realReceiptAmount| formatMoney}}</span>
      </div>
      <el-button @click="open" style="margin-left: auto;" :disabled="multipleSelection.length==0" type="primary">申请开票</el-button>
    </div>
    <div>
      <!--  :span-method="(...arg)=>strategySpanMethod(...arg,tableData)" -->
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @select="selectCheckOne"
        @select-all="selectAll"
        border
      >
        <el-table-column align="center" type="selection" width="78" prop="amount3" class-name="selectioncenter">
        </el-table-column>
        <el-table-column prop="orderNum" label="订单/支付单" min-width="140px"> 
          <template slot-scope="scope">
            <div v-if="[20,30].includes(scope.row.sourceType)">
              {{scope.row.orderNo || '---' }}
            </div>
            <div v-else>
              {{scope.row.sourceId || '---' }}
            </div>
          </template>  
        </el-table-column>
        <el-table-column prop="prodCodeStr" label="产品名称" min-width="140px"> 
          <template slot-scope="scope">
            <div>
              {{scope.row.prodCodeStr || '---' }}
            </div>
          </template>  
        </el-table-column>
        <el-table-column prop="payTypeStr" label="资金类型"> 
          <template slot-scope="scope">
            <div>
              {{scope.row.payTypeStr || '---' }}
            </div>
          </template> 
        </el-table-column>
        <el-table-column prop="taxRate" label="税率" width="80px"> 
          <template slot-scope="scope">
            <div>
              {{scope.row.taxRate || '---' }}
            </div>
          </template> 
        </el-table-column>
        <el-table-column prop="realReceiptAmount" label="实付金额">
          <template slot-scope="scope">
            <div>
              ￥{{scope.row.realReceiptAmount | formatMoney }}
            </div>
          </template>   
        </el-table-column>
        <el-table-column prop="realReceiptAmount" label="可开票金额">
          <template slot-scope="scope">
            <div>
              ￥{{scope.row.realReceiptAmount | formatMoney }}
            </div>
          </template>    
        </el-table-column>
        <el-table-column prop="payTime" label=" 支付时间" width="160px">
          <template slot-scope="scope">
            <div>
              {{scope.row.payTime | format('YYYY-MM-DD HH:mm:ss') }}
            </div>
          </template>  
        </el-table-column>
      </el-table>
    </div>
    <!-- 申请发票 -->
    <!-- 申请发票 -->
    <div class="">
      <el-dialog
        :title="invoiceFlage?'申请开票':'发票信息确认'"
        :visible.sync="dialogVisible"
        :width="invoiceFlage?'700px':'568px'"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :destroy-on-close="true"
        custom-class="invoicedialog"
        @closed="handleClose"
      >
        <div v-if="invoiceFlage">
          <el-form class="formItem" label-position="left" :model="formData" :rules="rules" ref="ruleForm" >
            <el-form-item :label="'发票类型'" label-width="135px">
              <el-button :class="formData.type==3?'activeClass':''" @click="activeNameFun(3)">数电发票(增值税专用发票)</el-button>
              <el-button :class="formData.type==4?'activeClass':''" @click="activeNameFun(4)">数电发票(普通发票)</el-button>
            </el-form-item>
            <div class="borderLine"></div>
            <el-form-item :label="'发票信息'" class="invoiceInfoTitle">
            </el-form-item>
            <el-form-item :label="'企业名称（全称）'" label-width="135px" prop="companyName">
              <el-input v-model="formData.companyName" placeholder="请输入" ></el-input>
            </el-form-item>
            <el-form-item :label="'纳税人识别号'" label-width="135px" prop="identityCard">
              <el-input v-model="formData.identityCard" placeholder="请输入" ></el-input>
            </el-form-item>
            <el-form-item :label="'开票金额'"  label-width="135px" prop="amount">
              <el-input class="amountInput" v-model="formData.amount" :disabled="true" placeholder="请输入"></el-input>
              <span>可开票金额<span class="valueamount">￥{{ formData.amount| formatMoney }}</span>RMB</span>
            </el-form-item>
            <div class="borderLine"></div>
            <el-form-item :label="'收件人信息'" class="invoiceInfoTitle">
            </el-form-item>
            <el-form-item :label="'电子邮箱'"  label-width="135px" prop="email">
              <el-input v-model="formData.email" placeholder="请输入" ></el-input>
            </el-form-item>
          </el-form>
          <div class="invoiceTips">
            温馨提示：请确认发票信息正确无误，HAIZOL.COM核对后会将数电发票投递至您的电子邮箱
          </div>
        </div>
        <div v-if="!invoiceFlage">
          <ul class="ulList">
            <li>
              <div class="label">发票类型</div>
              <div class="value">{{ typeArr[formData.type] }}</div>
            </li>
            <li>
              <div class="label">申请开票金额</div>
              <div class="value valueamount">￥{{ formData.amount| formatMoney }}</div>
            </li>
            <li>
              <div class="label">企业名称（全称）</div>
              <div class="value">{{ formData.companyName }}</div>
            </li>
            <li>
              <div class="label">纳税人识别号</div>
              <div class="value">{{ formData.identityCard }}</div>
            </li>
            <li>
              <div class="label">电子邮箱</div>
              <div class="value">{{ formData.email }}</div>
            </li>
          </ul>
        </div>
        <span slot="footer" class="dialog-footer">
          <div v-if="invoiceFlage">
            <el-button @click="handleClose">取消</el-button>
          <el-button type="primary" @click="sureFlag(false)"
            >确认提交</el-button
          >
          </div>
          <div v-if="!invoiceFlage" class="submitfootDiv">
            <el-checkbox class="submitfootcheckbox" v-model="checked">我已确认上述发票信息填写无误</el-checkbox>
            <div class="submitfootBtn">
              <el-button :disabled="!checked" @click="submitInfo" type="primary">确认</el-button>
              <el-button @click="sureFlag(true)">返回修改</el-button>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {invoiceGeneratorList,invoiceApplication} from "@/utils/api/invoice"
export default {
  data() {
    // 邮箱校验
    var checkEmail = (rule, value, callback) => {
      const reg =
        /^([a-zA-Z0-9_\-.]+)@(([a-zA-Z0-9-]+\.)+)([a-zA-Z]{2,10}|[0-9]{1,3})$/;
      if (value === "" || !value) {
        return callback(new Error('请输入电子邮箱'));
      }
      else if (!reg.test(value)) {
        return callback(new Error('请输入正确邮箱格式'));
      } else {
        callback();
      }
    };
    return {
      loading:false,
      tableData: [],
      multipleSelection: [],
      dialogVisible: false,
      SpanMethodProps:{
        row: '',
        column: '',
        rowIndex: 0,
        columnIndex: 0,
      },
      typeArr:{3:'数电发票(增值税专用发票)',4:'数电发票(普通发票)'},
      formData:{
        companyName:'',
        identityCard:'',
        amount:'',
        email:'',
        type:3
      },
      rules:{
        companyName: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        identityCard: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        amount: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        email: [
        { required: true, validator: checkEmail, trigger: "blur" },
        ],
      },
      invoiceFlage:true,
      checked: false,
      searchData:{
        "curPage": 1,
        "pageSize": 10,
        "attribute": "",
        "sortType": 0
      },
      realReceiptAmount:0,
      formDataAmount:0,

    };
  },
  mounted(){
    this.getInvoiceGeneratorList()
    console.log(this.$store.state.userInfo)
    this.formData.companyName=this.$store.state.userInfo.compCnName
  },
  methods: {
    // 发票接口
   async getInvoiceGeneratorList(){
      const res=await invoiceGeneratorList(this.searchData)
      if(res.rspResult.bizCode==200){
        this.tableData=res.rspListData.list
        this.realReceiptAmount=0
        this.tableData.map(res => this.realReceiptAmount=this.realReceiptAmount+res.realReceiptAmount)
        // this.formData.companyName=this.$store.state.userInfo.compCnName
      }
    },
    handleTableData(tableData){
      let rowSpanList = [],
      position = 0;
      for (let i = 0; i < tableData.length; i++) {
          if (i === 0) {
            rowSpanList.push(1)
              position = 0
          } else {
            // 判断当前元素属性值与上一个元素属性值是否相同
            if (tableData[i]['sourceId']) {
              if (tableData[i]['sourceId'] == tableData[i - 1]['sourceId']) {
                rowSpanList[position] += 1; //项目名称相同，合并到同一个数组中
                rowSpanList.push(0);
              } else {
                rowSpanList.push(1);
                position = i;
              }
            } else {
              rowSpanList.push(1);
              position = i;
            }
          }
      }
      return rowSpanList
    },
  // 当前行row、当前列column、当前行号rowIndex、当前列号columnIndex
    strategySpanMethod({ row, column, rowIndex, columnIndex }, data) {
      // columnIndex判断第一列或第二列合并 列数从0开始
      if(columnIndex == 0){
        // column.property是表头的key 
        let spanArr = this.handleTableData(data)
        const _row = spanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
            rowspan: _row,
            colspan: _col
        }
      }
    },
    // 全选
    // //全选先把所有id拿到并去重
    selectAll(val) {
      let _arr = [...new Set(val.map(res => res))]
      this.multipleSelection =_arr;
      this.formDataAmount=0
      val.map(res => this.formDataAmount=this.formDataAmount+res.realReceiptAmount)
    },
    // 单选
    // //isSelect true为选中 false 为取消
    selectCheckOne(val, row){
      let isSelect = val.length && val.indexOf(row) > -1
      let n = this.multipleSelection.findIndex(v => {
        return v.sourceId == row.sourceId
      })
      if (isSelect) {
        if (n < 0) this.multipleSelection.push(row)
        this.formDataAmount=this.formDataAmount+row.realReceiptAmount
      } else {
        if (n > -1) this.multipleSelection.splice(n, 1)
        this.formDataAmount=this.formDataAmount-row.realReceiptAmount
      }
    },
    //弹框关闭
    handleClose() {
      this.dialogVisible=false
    
      this.formData={
        companyName:this.$store.state.userInfo.compCnName,
        identityCard:'',
        amount:'',
        email:'',
        type:3
      },
      this.$nextTick(()=>{
        this.invoiceFlage=true
      })
    },
    open(){
      this.dialogVisible=true
      console.log(this.multipleSelection)
      this.formData.amount=this.formDataAmount.toFixed(2)
    },
    activeNameFun(val){
      this.formData.type=val
    },
    sureFlag(val){
      if(!val){
        new Promise((resolve, reject) => {
          this.$refs["ruleForm"].validate(valid => {
            resolve(valid)
          }).catch((err) => {
            reject(err);
          })
        }).then((resolve)=>{
          if(resolve){
            this.invoiceFlage=val
          }
        })
      }else{
        this.invoiceFlage=val
      }
    },
    submitInfo(){
      if(!this.loading){
        this.loading=true
        let invoiceCorrelationList=[]
        this.multipleSelection.map(item=>{
          let temp={
            sourceId:'',
            sourceType:''
          }
          temp.sourceId=item.sourceId
          temp.sourceType=item.sourceType
          invoiceCorrelationList.push(temp)
        })

        const parmas ={
          companyName:this.formData.companyName.trim(),
          identityCard:this.formData.identityCard.trim(),
          amount:this.formData.amount,
          email:this.formData.email.trim(),
          type:this.formData.type,
          invoiceCorrelationList:invoiceCorrelationList
        }
        invoiceApplication(parmas).then(res=>{
          if(res.rspResult.bizCode==200){
            this.$message.success(res.rspResult.message);
            this.handleClose()
            this.getInvoiceGeneratorList()
            this.formDataAmount=0
            this.multipleSelection=[]
            setTimeout(() => {
              this.loading=false
            }, 1000);
          }else{
            this.loading=false
          }
        }).catch((err)=>{
        this.loading=false
      })
      }

    }
  },
};
</script>

<style lang="scss" scoped>
.detail {
  margin: 20px 0;
  display: flex;
  .detailDiv{
    color: #16181A;
    margin-left: 31px;
    .valueamounttext{
      margin-left: 48px;
    }
  }
}
.activeClass{
  background: #318ced1a;
  border: 1px solid #318CED;
  border-radius: 4px;
  color: #318CED;
}
.borderLine{
  border-bottom: 1px solid #E5E8ED;
  height: 1px;
}
::v-deep .formItem{
  padding-right: 12px;
  .el-form-item{
    padding-left: 20px;
    .el-form-item__label{
      color: #4f5d78;
    }
    .amountInput{
      width: 248px;
      margin-right: 20px;
    }
  }
  .invoiceInfoTitle{
    .el-form-item__label{
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      font-size: 14px;
      color: #16181A ;
      margin-top: 12px;
    }
  }
}
.invoiceTips{
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #EF2A2A;
  margin-left: 20px;
}
.ulList{
  border: 1px solid #CFD5DF;
  border-radius: 4px;
  padding: 24px 20px 0px 20px;
  li{
    display: flex;
    margin-bottom: 24px;
    .label{
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #4F5D78;
      width: 152px;
    }
    .value{
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #16181A;
    }
  }
}
.submitfootDiv{
  display: flex;
  .submitfootcheckbox{
    line-height: 28px;
    font-weight: 400;
    font-size: 14px;
    color: #16181A;
  }
  .submitfootBtn{
    margin-left: auto;
  }
}
.valueamount{
  color: #FF7F2A !important;
}

</style>

<style lang="scss">
.invoicedialog{
  .el-dialog__body{
    padding: 16px 20px !important;
  }
  .el-dialog__header{
    padding-bottom: 0px;
    .el-dialog__title{
      font-family: SourceHanSansCN-Bold;
      font-weight: 700;
      font-size: 16px;
      color: #16181A;
    }
  }
}
.selectioncenter{
  .el-table--border .el-table__cell:first-child .cell{

  }
}
</style>